export default {
    mode: ({wallet}) => wallet.mode,
    tab: ({wallet}) => wallet.tab,
    method: ({wallet}) => wallet.method,
    bonuses: {
        error: ({wallet}) => wallet.bonuses.error,
        message: ({wallet}) => wallet.bonuses.message,
        button: ({wallet}) => wallet.bonuses.button
    },
    history: {
        loaded: ({wallet}) => wallet.history.loaded,
        list: ({wallet}) => wallet.history.list,
        count: ({wallet}) => wallet.history.count,
    },
    methods: {
        chime_deposit: ({wallet}) => wallet.methods.chime_deposit,
        chime_cashout: ({wallet}) => wallet.methods.chime_cashout,
        cashapp_deposit: ({wallet}) => wallet.methods.cashapp_deposit,
        cashapp_cashout: ({wallet}) => wallet.methods.cashapp_cashout,
        crypto_deposit: ({wallet}) => wallet.methods.crypto_deposit,
        cards_deposit: ({wallet}) => wallet.methods.cards_deposit,
        zelle_deposit: ({wallet}) => wallet.methods.zelle_deposit,
        cashapp_merchant_deposit: ({wallet}) => wallet.methods.cashapp_merchant_deposit,
        cashapp_p2p_deposit: ({wallet}) => wallet.methods.cashapp_p2p_deposit,
        applepay_deposit: ({wallet}) => wallet.methods.applepay_deposit,
        googlepay_deposit: ({wallet}) => wallet.methods.googlepay_deposit,
        paypal_deposit: ({wallet}) => wallet.methods.paypal_deposit
    }
}